












import Vue from "vue";
import Component from "vue-class-component";
import * as firebase from "firebase/app";
import "firebase/auth";

@Component({})
export default class Login extends Vue {
  checkUser(): void {
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$router.push({ name: "hello" });
      } else {
        Login.signIn();
      }
    });
  }

  static signIn(): void {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithRedirect(provider);
    firebase.auth().getRedirectResult().then().catch();
  }
}
